































import { Component, Vue } from "vue-property-decorator";
import { getSettings, postSettings } from "../api";
import { namespace } from "vuex-class";
import { SnackbarInterface } from "shared/store/snackbar/state";

const snackStore = namespace("snackbar");

@Component
export default class SettingsBlock extends Vue {
  @snackStore.Mutation defaultError!: () => void;
  @snackStore.Mutation setSnackbar!: (payload: SnackbarInterface) => void;

  immediate = false;
  weekly = false;

  update(): void {
    postSettings({
      immediate: this.immediate,
      weekly: this.weekly,
    })
      .then(() => {
        this.setSnackbar({
          text: this.$t("notifications.settings.success").toString(),
          timeout: 3000,
          color: "success",
        });
      })
      .catch(() => {
        this.defaultError();
      });
  }

  mounted(): void {
    getSettings().then((s) => {
      this.immediate = s.immediate;
      this.weekly = s.weekly;
    });
  }
}
